import axios, {AxiosInstance} from 'axios';

const instance: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BOT_URL,
})

const dummyInstance: AxiosInstance = axios.create({
  baseURL: '/chat/statics/dummy/',
})

export const $axios = instance
export const $dummy = dummyInstance
